module.exports = "/_next/static/images/6565dc866016aed4d30a1a5d00dcded0-credit-card-limit@0.5x.png.webp";